const MAX_SECONDS = 3 * 60 * 60;
  let remainingSeconds = MAX_SECONDS;
  let prev = { h: null, m: null, s: null };

  function updateTimer() {
    if (remainingSeconds > 0) {
      remainingSeconds--;
    } else {
      remainingSeconds = MAX_SECONDS;
    }

    const h = Math.floor(remainingSeconds / 3600);
    const m = Math.floor((remainingSeconds % 3600) / 60);
    const s = remainingSeconds % 60;

    if (s !== prev.s) animateChange('.timer-sec span', String(s).padStart(2, '0'));
    if (m !== prev.m) {
        document.querySelectorAll('.timer-min span').forEach(el => {
            el.textContent = String(m).padStart(2, '0');
        });
    }

    if (h !== prev.h) {
        document.querySelectorAll('.timer-hr span').forEach(el => {
            el.textContent = String(h).padStart(2, '0');
        });
    }

    prev = { h, m, s };
  }

  function animateChange(selector, newValue) {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.remove('slide-up');
     
      el.textContent = newValue;
      void el.offsetWidth;
      el.classList.add('slide-down');

      setTimeout(() => {
        el.classList.remove('slide-down');
        el.classList.add('slide-up');
      }, 700); 
      
    });
  }

  updateTimer();
  setInterval(updateTimer, 1000);